import Repository from './Repository';
import {AxiosResponse} from "axios";
import {ThietBi} from "@/models/thietBi";
import {LichSuBanGiao} from "@/models/lichSuBanGiao";
import {NhomThietBi} from "@/models/nhomThietBi";
import {ThietBiReject} from "@/models/thietBiReject";
import {ThietBiNgungHoatDong} from "@/models/thietBiNgungHoatDong";
import {ThietBiUpdate} from "@/models/thietBiUpdate";
import {BienBan} from "@/models/bienBan";
import {LichSuSuaChuaCreate, LichSuSuaChuaHoanThanhUpdate, LichSuSuaChuaUpdate} from "@/models/lichSuSuaChuaCreate";

const resource = '/quanlytaisan';

export default new class{
    createThietBi(thietBi: any): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createThietBi`,thietBi);
    }
    updateCapChatLuong(id: number, capChatLuong: number): Promise<AxiosResponse<any>> {
        return Repository.post(`${resource}/updateCapChatLuong`, { id, capChatLuong });
    }
    exportKiemKeCapChatLuong(year: number, khoaPhongId: number): Promise<AxiosResponse<Blob>> {
        return Repository.get(`${resource}/exportKiemKeCapChatLuong/${year}/${khoaPhongId}`, { responseType: 'blob' });
    }
    downloadImportThietBiTemplate(): Promise<AxiosResponse<Blob>>{
        return Repository.get(`${resource}/importThietBi/template`, { responseType: 'blob' });
    }
    previewImportThietBi(file: File): Promise<AxiosResponse<any>>{
        const formData = new FormData();
        formData.append('file', file);
        return Repository.post<any>(`${resource}/importThietBi/preview`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
    confirmImportThietBi(rows: any[]): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/importThietBi/confirm`, { rows });
    }
    updateThietBi(thietBiUpdate: ThietBiUpdate): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateThietBi`,thietBiUpdate);
    }
    getListThietBi(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThietBi`);
    }
    deleteThietBi(id: number): Promise<AxiosResponse<any>>{
        return Repository.delete<any>(`${resource}/deleteThietBi/${id}`);
    }
    confirmThietBi(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/confirmThietBi/${id}`);
    }
    tranferThietBi(idThietBi: number, idKhoaPhongNhan: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/tranferThietBi/${idThietBi}/${idKhoaPhongNhan}`);
    }
    createLichSuBanGiao(lichSuBanGiao: LichSuBanGiao): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createLichSuBanGiao`,lichSuBanGiao);
    }
    getListLichSuBanGiao(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListLichSuBanGiao`);
    }
    deleteLichSuBanGiao(id: number): Promise<AxiosResponse<any>>{
        return Repository.delete<any>(`${resource}/deleteLichSuBanGiao/${id}`);
    }
    createNhomThietBi(nhomThietBi: NhomThietBi): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createNhomThietBi`, nhomThietBi, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    updateNhomThietBi(nhomThietBi: NhomThietBi): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateNhomThietBi`, nhomThietBi, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    getListNhomThietBi(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListNhomThietBi`);
    }
    deleteNhomThietBi(id: number): Promise<AxiosResponse<any>>{
        return Repository.delete<any>(`${resource}/deleteNhomThietBi/${id}`);
    }
    getListChiTietLoaiThietBi(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListChiTietLoaiThietBi/${id}`);
    }
    createChiTietLoaiThietBi(chiTietLoaiThietBi: {
        tenLoaiThietBi: string;
        thoiGianHaoMon: number;
        tyLeHaoMon: number;
        idNhomThietBi: number;
    }): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createChiTietLoaiThietBi`, chiTietLoaiThietBi, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    updateChiTietLoaiThietBi(chiTietLoaiThietBi: {
        id: number;
        tenLoaiThietBi: string;
        thoiGianHaoMon: number;
        tyLeHaoMon: number;
        idNhomThietBi: number;
    }): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateChiTietLoaiThietBi`, chiTietLoaiThietBi, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    deleteChiTietLoaiThietBi(id: number): Promise<AxiosResponse<any>>{
        return Repository.delete<any>(`${resource}/deleteChiTietLoaiThietBi/${id}`);
    }
    getListThietById(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThietBiById/${id}`);
    }
    getListKhoaPhong(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListKhoaPhong`);
    }
    createKhoaPhong(khoaPhong: { tenKhoaPhong: string }): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createKhoaPhong`, khoaPhong, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    updateKhoaPhong(khoaPhong: { id: number; tenKhoaPhong: string }): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateKhoaPhong`, khoaPhong, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    deleteKhoaPhong(id: number): Promise<AxiosResponse<any>>{
        return Repository.delete<any>(`${resource}/deleteKhoaPhong/${id}`);
    }
    getListThietBiChuyenGiao(t1: number, t2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThietBiChuyenGiao/${t1}/${t2}`);
    }
    getListThietBiTiepNhan(t1: number, t2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThietBiTiepNhan/${t1}/${t2}`);
    }
    getListLichSuBanGiaoById(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListLichSuBanGiaoById/${id}`);
    }
    getLichSuThietBiTongHop(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getLichSuThietBiTongHop/${id}`);
    }
    getListThietBiHetHan(t1: number, t2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThietBiHetHan/${t1}/${t2}`);
    }
    getListThietBiHoatDong(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThietBiHoatDong`);
    }
    getListThietBiAll(t1: number, t2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThietBiAll/${t1}/${t2}`);
    }
    getListThietBiReject(t1: number, t2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/listRejectThietBi/${t1}/${t2}`);
    }
    rejectThietBi(thietBiReject: ThietBiReject): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/rejectThietBi`,thietBiReject);
    }
    getListSoLuongTiepNhanTrongNam(time: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListSoLuongTiepNhanTrongNam/${time}`);
    }
    getListSoLuongTiepNhanTrong12Thang(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListSoLuongTiepNhanTrong12Thang`);
    }
    getListSoLuongQuaHanTrong12Thang(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListSoLuongQuaHanTrong12Thang`);
    }
    getUserInfo(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getUserInfo`);
    }
    deactiveThietBi(thietBiNgungHoatDong: ThietBiNgungHoatDong): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/deactiveThietBi`, thietBiNgungHoatDong);
    }
    getListThietBiNgungHoatDong(t1: number, t2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThietBiNgungHoatDong/${t1}/${t2}`);
    }
    waitingForLiquidationThietBi(thietBiNgungHoatDong: ThietBiNgungHoatDong): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/waitingForLiquidationThietBi`, thietBiNgungHoatDong);
    }
    cancelLiquidationThietBi(idThietBi: number): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/cancelLiquidationThietBi/${idThietBi}`);
    }
    getListThietBiChoThanhLy(t1: number, t2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThietBiChoThanhLy/${t1}/${t2}`);
    }
    getListThongKeTrong12Thang(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThongKeTrong12Thang`);
    }
    getListThongKeThietBiHienCo(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThongKeThietBiHienCo`);
    }
    getListThongKeTheoKhoaTrong12Thang(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThongKeTheoKhoaTrong12Thang`);
    }
    exportBaoCao(list: ThietBi[], id: number): Promise<AxiosResponse<Blob>>{
        return Repository.post(`${resource}/exportBaoCao/${id}`, list, { responseType: 'blob' });
    }
    createBanGiao(bienBan: BienBan): Promise<AxiosResponse<Blob>>{
        return Repository.post(`${resource}/createBanGiao`, bienBan, { responseType: 'blob' });
    }
    getListThietBiTheoKhoa(id: number, t1: number, t2: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListThietBiTheoKhoa/${id}/${t1}/${t2}`);
    }
    createBaoCaoTheoGiaTri(price: number, kind: number, option: number): Promise<AxiosResponse<Blob>>{
        return Repository.get(`${resource}/createBaoCaoTheoGiaTri/${price}/${kind}/${option}`, { responseType: 'blob' });
    }
    createBaoCaoTongHop(year: number, khoaPhongId: number, option: number): Promise<AxiosResponse<Blob>>{
        return Repository.get(`${resource}/baoCaoTongHop/${year}/${khoaPhongId}/${option}`, { responseType: 'blob' });
    }
    exportKiemKeThietBi(year: number, khoaPhongId: number): Promise<AxiosResponse<Blob>>{
        return Repository.get(`${resource}/exportKiemKeThietBi/${year}/${khoaPhongId}`, {
            responseType: 'blob'
        });
    }
    exportLichSuThietBi(idThietBi: number, tuNgay?: string, denNgay?: string): Promise<AxiosResponse<Blob>>{
        return Repository.get(`${resource}/exportLichSuThietBi/${idThietBi}`, {
            responseType: 'blob',
            params: {
                tuNgay: tuNgay || undefined,
                denNgay: denNgay || undefined,
            },
        });
    }
    createLichSuSuaChua(lichSuSuaChuaCreate :LichSuSuaChuaCreate): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createLichSuSuaChua`, lichSuSuaChuaCreate);
    }
    updateLichSuSuaChua(lichSuSuaChuaUpdate :LichSuSuaChuaUpdate): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateLichSuSuaChua`, lichSuSuaChuaUpdate, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    updateLichSuSuaChuaHoanThanh(lichSuSuaChuaHoanThanhUpdate :LichSuSuaChuaHoanThanhUpdate): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateLichSuSuaChuaHoanThanh`, lichSuSuaChuaHoanThanhUpdate, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    getListLichSuSuaChua(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListLichSuSuaChua`);
    }
    getListLichSuSuaChuaYeuCau(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListLichSuSuaChuaYeuCau`, {
            headers: { accept: 'text/plain' },
        });
    }
    getListBaoDuong(filters: {
        trangThai?: boolean;
        loaiThoiGian?: 'baoDuong' | 'baoDuongTiepTheo';
        tuNgay?: string;
        denNgay?: string;
    } = {}): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoDuong`, {
            headers: { accept: 'text/plain' },
            params: filters,
        });
    }
    getListBaoDuongDenHan(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getListBaoDuongDenHan`, {
            params: { _: Date.now() },
            headers: { 'Cache-Control': 'no-cache' },
        });
    }
    getThongBaoBaoDuong(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getThongBaoBaoDuong`, {
            params: { _: Date.now() },
            headers: { 'Cache-Control': 'no-cache' },
        });
    }
    getCauHinh(): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/getCauHinh`, {
            headers: { accept: 'text/plain' },
        });
    }
    createCauHinh(payload: { thoiGianBaoDuong: number }): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createCauHinh`, payload, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    updateCauHinh(payload: { thoiGianBaoDuong: number }): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateCauHinh`, payload, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    createLichSuBaoDuong(payload: {
        idThietBi: number;
        thoiGianBaoDuong: string;
        thoiGianBaoDuongTiepTheo: string;
        ghiChu?: string;
        soTien: number;
    }): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/createLichSuBaoDuong`, payload, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    updateLichSuBaoDuong(payload: {
        id: number;
        idThietBi: number;
        thoiGianBaoDuong: string;
        thoiGianBaoDuongTiepTheo: string;
        trangThai: boolean;
        ghiChu?: string;
        soTien: number;
    }): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/updateLichSuBaoDuong`, payload, {
            headers: { 'Content-Type': 'application/json-patch+json' },
        });
    }
    deleteLichSuBaoDuong(id: number): Promise<AxiosResponse<any>>{
        return Repository.delete<any>(`${resource}/deleteLichSuBaoDuong/${id}`);
    }
}
